import React from 'react'

import './Footer.scss';

const Footer = () => {
    return (
        <div>
            <h1></h1>
        </div>
    )
}

export default Footer